import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {StellenangeboteComponent} from './stellenangebote/stellenangebote.component';
import {BewerbungComponent} from './bewerbung/bewerbung.component';
import {StellenbeschreibungComponent} from './stellenbeschreibung/stellenbeschreibung.component';
import {MenuComponent} from './menu/menu.component';

const routes: Routes = [
    {path: '', component: MenuComponent},
    {path: 'stellen', component: StellenangeboteComponent},
    {path: 'ausbildung', component: StellenangeboteComponent},
    {path: 'bewerbung/:id', component: BewerbungComponent},
    {path: 'initiativ', component: BewerbungComponent, data: {spezialstelle: 'Initiativbewerbung'}},
    {path: 'praktika', component: BewerbungComponent, data: {spezialstelle: 'Praktikum'}},
    {path: 'aushilfe', component: BewerbungComponent, data: {spezialstelle: 'Ferienhelfer'}},
    {path: 'stelle/:id', component: StellenbeschreibungComponent}
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
